import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { cn } from '../utils/cn';
/** Kleiner Hinweis-/Fehlertext unter einem Feld (MUI-`FormHelperText`-Ersatz). */
export const HelperText = forwardRef(function HelperText({ error, className, ...rest }, ref) {
    return _jsx("p", { ref: ref, className: cn('sec-helper-text', error && 'sec-helper-text--error', className), ...rest });
});
